import React from 'react';
import { useNavigate } from 'react-router-dom';

interface DrillToolbarProps {
  isAdmin?: boolean;
}

export const DrillToolbar: React.FC<DrillToolbarProps> = ({
  isAdmin = false,
}) => {
  const navigate = useNavigate();

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="toolbar toolbar-actions-only">
      <div className="toolbar-actions">
        {/* Primary creation actions */}
        <button onClick={() => navigate('/training-drills/edit/new')} className="btn btn-success">
          + Add Drill
        </button>
        <button onClick={() => navigate('/training-drills/youtube-search')} className="btn btn-outline-primary">
          Import from YouTube
        </button>
        {/* Maintenance actions - visually separated */}
        <span className="toolbar-divider" />
        <button onClick={() => navigate('/training-drills/reseed')} className="btn btn-outline-danger btn-sm">
          Reseed Database
        </button>
      </div>
    </div>
  );
};
